import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Curtain Icon Style 05 - Window (Material Symbol)
 * Window icon - good for general window covering
 * - isOn = true (open): 青綠色
 * - isOn = false (closed): 灰色
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:window
 */
export const Style05_Window: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-teal-500' : 'text-slate-400';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      window
    </span>
  );
};

export default Style05_Window;
